var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerIconCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-capture"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33203 6.66634V4.99967C3.33203 4.55765 3.50763 4.13372 3.82019 3.82116C4.13275 3.5086 4.55667 3.33301 4.9987 3.33301H6.66536M3.33203 13.333V14.9997C3.33203 15.4417 3.50763 15.8656 3.82019 16.1782C4.13275 16.4907 4.55667 16.6663 4.9987 16.6663H6.66536M13.332 3.33301H14.9987C15.4407 3.33301 15.8646 3.5086 16.1772 3.82116C16.4898 4.13372 16.6654 4.55765 16.6654 4.99967V6.66634M13.332 16.6663H14.9987C15.4407 16.6663 15.8646 16.4907 16.1772 16.1782C16.4898 15.8656 16.6654 15.4417 16.6654 14.9997V13.333M7.4987 9.99967C7.4987 10.6627 7.76209 11.2986 8.23093 11.7674C8.69977 12.2363 9.33566 12.4997 9.9987 12.4997C10.6617 12.4997 11.2976 12.2363 11.7665 11.7674C12.2353 11.2986 12.4987 10.6627 12.4987 9.99967C12.4987 9.33663 12.2353 8.70075 11.7665 8.23191C11.2976 7.76307 10.6617 7.49967 9.9987 7.49967C9.33566 7.49967 8.69977 7.76307 8.23093 8.23191C7.76209 8.70075 7.4987 9.33663 7.4987 9.99967Z",
    stroke: "#5EA1FF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconCapture);
export default __webpack_public_path__ + "static/media/tabler-icon-capture.eeac684d9cf98ff39b437ac707b13598.svg";
export { ForwardRef as ReactComponent };